import { useTimePilotT } from "@/i18n/useTimePilotT";
import * as React from 'react';

const DisplayOrder = React.memo(function EventTypes(props: any) {
  const t = useTimePilotT();
  return (
    <div aria-label={t("viewers.displayOrder")} className={`flex justify-center items-center pt-[0px]`}>
      {props.value}
    </div>
  );
});

export default DisplayOrder;
